import { AfterContentInit, AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { SignatureInputComponent } from '@components/signature-input/signature-input.component';
// eslint-disable-next-line @typescript-eslint/naming-convention
import SignaturePad from 'signature_pad';
@Component({
  selector: 'gc-drawable-image',
  templateUrl: './drawable-image.component.html',
  styleUrls: ['./drawable-image.component.scss'],
  providers: [{ provide: MatFormFieldControl, useExisting: DrawableImageComponent }],
  standalone: false,
})
export class DrawableImageComponent extends SignatureInputComponent implements AfterViewInit, AfterContentInit, OnDestroy {
  private _image: string;
  image = new Image();
  @ViewChild('sigPad', { static: false }) canvas: ElementRef<HTMLCanvasElement>;

  ngAfterContentInit() {
    this._image = this._value;
  }

  // Yes this is bad, but when creating multiple canvases the offset is 0 on first load, untill its vissible.
  // Meaning you cant get the ratio's correct. So we need to wait untill the canvas really is vissible.
  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.canvas.nativeElement);
    this.signaturePad.addEventListener('endStroke', () => this.onSignatureEnd());
    this.signaturePad.addEventListener('beginStroke', () => this.onSignatureBegin());
    this.calculateSize();

    const mobile = this.displayService.isMobile$.value;
    this.canvas.nativeElement.parentElement.addEventListener(
      mobile ? 'touchstart' : 'mouseenter',
      () => {
        this.calculateSize();
      },
      { once: true },
    );

    this.image.addEventListener(
      'load',
      () => {
        const canvas = this.canvas.nativeElement;
        const context = canvas.getContext('2d');
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const containerWidth = canvas.parentElement?.offsetWidth || this.image.naturalWidth;
        const imageRatio = this.image.naturalWidth / this.image.naturalHeight;
        const canvasWidth = containerWidth;
        const canvasHeight = canvasWidth / imageRatio;

        canvas.width = canvasWidth * ratio;
        canvas.height = canvasHeight * ratio;

        context.scale(ratio, ratio);
        context.drawImage(this.image, 0, 0, canvasWidth, canvasHeight);
        this.signaturePad.clear();
        this.signaturePad.fromDataURL(this._image, {
          width: canvasWidth,
          height: canvasHeight,
        });
      },
      true,
    );
  }

  calculateSize() {
    this.image.src = this._image || '';
  }
}
